/*----------------------------------------------------------------------------*\
  Shows or hides elements based on the selected radio button value
\*----------------------------------------------------------------------------*/

export default function(options) {
  const _defaults = {
    selector: '.js-radio-visibility',
    $selectors() {
      return document.querySelectorAll(this.selector);
    },
    exists() {
      return this.$selectors().length > 0;
    },
    triggerEvent: 'change',
  };

  const _settings = {
    ..._defaults,
    ...options,
  };

  const _changeVisibility = event => {
    const $radio = event.currentTarget;

    // Ignore unchecked radios
    if (!$radio.checked) return;

    const className = $radio.dataset.toggleClass || 'u-hide';
    const conditionalValues = $radio.dataset.conditionalValues.split(',');
    const targetSelectors = $radio.dataset.targetSelectors.split(',');
    const editing = $radio.dataset.editing;
    const originalValue = $radio.dataset.originalValue;

    if (conditionalValues.length !== targetSelectors.length) {
      throw new Error(
        'JS radio visibility error: conditions vs targets length mismatch.'
      );
    }

    // Hide all targets first
    const $targets = document.querySelectorAll(targetSelectors);

    $targets.forEach($target => {
      $target.classList.add(className);

      const controls = $target.querySelectorAll(
        'input[required], textarea[required]'
      );

      controls.forEach(control => {
        control.required = false;

        const cacheId = `${control.id}_cache`;
        const cache = document.getElementById(cacheId);

        if (cache == null || cache.value.length === 0) {
          control.dataset.required = 'true';
        }
      });
    });

    // Show matching target
    conditionalValues.forEach((conditionalValue, index) => {
      if ($radio.value == conditionalValue) {
        const targetSelector = targetSelectors[index];
        const $targets = document.querySelectorAll(targetSelector);

        $targets.forEach($target => {
          $target.classList.remove(className);

          const controls = $target.querySelectorAll(
            'input[data-required="true"], textarea[data-required="true"]'
          );

          controls.forEach(control => {
            if (
              control.type === 'file' &&
              editing &&
              originalValue == conditionalValue
            ) {
              // Skip required for unchanged file uploads
            } else {
              control.required = true;
            }
          });
        });
      }
    });
  };

  const destroy = () => {
    if (!_settings.exists()) return;

    _settings.$selectors().forEach($radio => {
      $radio.removeEventListener(
        _settings.triggerEvent,
        _changeVisibility
      );
    });
  };

  const reinit = () => {
    destroy();
    init();
  };

  const init = () => {
    if (!_settings.exists()) return;

    _settings.$selectors().forEach($radio => {

      $radio.addEventListener(
        _settings.triggerEvent,
        _changeVisibility
      );

      if ($radio.checked) {
        _changeVisibility({ currentTarget: $radio });
      }
    });
  };

  return {
    destroy,
    reinit,
    init,
  };
}
